//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
let d=[[[0,"Type",1,0]],[[["num_targets"],"GetTargetBodies",{R_:{target_bodies:"Body[]"}},0,0],[["target_bodies"],"SetTargetBodies",{},1,0],[[],"GetTargetBodiesCollector",{R_:{targetBodiesCollector:"ScCollector"}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.BooleanOperation = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.BooleanOperation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.BooleanOperation.BooleanType = Object.freeze({
    "Create" : "Create", "Unite" : "Unite", "Subtract" : "Subtract", "Intersect" : "Intersect", "Sew" : "Sew"});

export default SPLM;